import * as React from 'react';

import {createIcon} from '@chakra-ui/icons';

/** Expuesto aparte para poder pintarlo en SVG plano, fuera del árbol de Chakra. */
/**
 * Disco blanco: cualquier color de marca aquí se confunde con otro estado. El
 * contorno gris es lo que lo salva sobre los tipos de evento claros de la
 * paleta (#FFD25C, #fccbd1, #9fcfc9…), donde el blanco solo se perdería.
 */
export const eventoPendientePath = (
  <circle
    cx='12'
    cy='12'
    r='10.5'
    fill='#FFFFFF'
    stroke='#C4C3C4'
    strokeWidth='2'
  />
);

export const EventoPendienteIcon = createIcon({
  displayName: 'EventoPendienteIcon',
  viewBox: '0 0 24 24',
  path: eventoPendientePath,
});
